import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BalancedText } from '@tink/core/src/components/atoms/BalancedText/BalancedText';
import { Header } from '../../../../components/organisms/Header/Header';
import { Button } from '../../../../components/atoms/Button/Button';
import { Footer } from '../../../../components/atoms/Footer/Footer';
import { ScreenWrapper } from '../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { ProviderEntity } from '../../../../models/provider';
import { ContentBody } from '../../../../components/atoms/ContentBody/ContentBody';
import { PageView } from '../../../../models/analytics';
import { StyledError } from '../../../../components/screens/molecules/SubmitCredentialsScreen/SubmitCredentialsScreen.styles';
import { LegalDisclaimer } from '../../../../components/molecules/LegalDisclaimer/LegalDisclaimer';
import { ApplicationUnverifiedLabel } from '../../../../components/molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { messages } from '../../../messages';
import { Caption } from '../../../../components/atoms/Text/Text';
import { H1 } from '../../../../components/atoms/Heading/Heading';
import { QrCodeContainer } from '../../../../components/atoms/QRCodeContainer/QRCodeContainer.styles';
import { OrderedBulletList } from '../../../../core/atoms/OrderedBulletList/OrderedBulletList';
import { VisuallyHidden } from '../../../../core/atoms/VisuallyHidden/VisuallyHidden.styles';
import { BackButton } from '../../../../components/organisms/Header/HeaderMolecule';
import { QrCode as QrCodeDefault, QrCodeProps } from './QrCode';

export type QrHandoffViewProps = {
  userHintId: string | undefined;
  provider: ProviderEntity;
  qrCodeValue: string;
  QrCode?: React.ComponentType<QrCodeProps>;
  credentialsError?: string;
  isClientVerified: boolean;
  onSignIn: () => void;
} & BackButton;

export const QrHandoffView = ({
  userHintId,
  provider,
  qrCodeValue,
  onBack,
  onSignIn,
  credentialsError,
  isClientVerified,
  QrCode = QrCodeDefault,
}: QrHandoffViewProps) => {
  return (
    <ScreenWrapper>
      <Header
        addBottomMargin={false}
        onBack={onBack}
        pageView={PageView.SUBMIT_HANDOFF_CREDENTIALS_SCREEN}
      />

      <ContentBody>
        <H1 align="center" mt="xlarge" mx="normal">
          <BalancedText>
            <FormattedMessage
              {...messages.authenticateWith}
              values={{
                providerName: provider.displayName,
              }}
            />
          </BalancedText>
        </H1>
        {userHintId && <Caption>{userHintId}</Caption>}

        {credentialsError && <StyledError>{credentialsError}</StyledError>}
        <ApplicationUnverifiedLabel isVerified={isClientVerified} />
        {qrCodeValue && (
          <QrCodeContainer>
            <figure>
              <VisuallyHidden as="figcaption">
                <FormattedMessage {...messages.qrCodeCaption} />
              </VisuallyHidden>
              <QrCode value={qrCodeValue} />
            </figure>
          </QrCodeContainer>
        )}
        <OrderedBulletList>
          {[messages.openCamera, messages.followLink, messages.continueHere].map((message) => (
            <li key={message.id}>
              <FormattedMessage {...message} />
            </li>
          ))}
        </OrderedBulletList>

        <Footer as="div" stickToBottom>
          <Button color="primary" data-testid="handoff-opt-out" onClick={onSignIn}>
            <FormattedMessage {...messages.desktopSignIn} />
          </Button>
        </Footer>
      </ContentBody>
      <LegalDisclaimer provider={provider} pageView={PageView.SUBMIT_CREDENTIALS_SCREEN} />
    </ScreenWrapper>
  );
};
